import React, { FunctionComponent, JSX } from "react";

import BoySvg from "./assets/boy.svg?react";
import DownloadSvg from "./assets/download-svgrepo-com.svg?react";
import DocumentSvg from "./assets/document-svgrepo-com.svg?react";
import ToolsSvg from "./assets/tools-svgrepo-com.svg?react";
import GeniusSvg from "./assets/genius-svgrepo-com.svg?react";
import { useAuthentication } from "../../hooks/useAuthentication";
import useSubscription from "../../hooks/useSubscription";
import { ContentLayout } from "../common/Layout";
import { useUserIdParam } from "../../hooks/useUserIdParam";
import "./SpielgruppePlus.scss";

interface Props {
  isAuthenticated: boolean;
}

interface Feature {
  title: string;
  text: string;
  figure: JSX.Element;
}

const FEATURES: Feature[] = [
  {
    title: "Anmeldungsexport",
    text: "Eingegangene Anmeldungen können ganz bequem als Excel-Liste exportiert werden.",
    figure: <DownloadSvg />
  },
  {
    title: "Zusätzliche Formularfelder",
    text: "Diverse zusätzliche Feldtypen stehen zur Verfügung. E-Mail, Ganzzahlen, Checkboxen, Zwischentitel, etc.",
    figure: <DocumentSvg />
  },
  {
    title: "Individuelle E-Mail-Gestaltung",
    text: "Gestalten Sie Ihre generierten E-Mails nach belieben. Passen Sie Text und Farben an Ihre Spielgruppe an.",
    figure: <ToolsSvg />
  },
  {
    title: "Viele weitere Funktionen folgen",
    text: "Wir entwickeln laufend zusätzliche Module, welche unseren Spielgruppen das Leben erleichtern.",
    figure: <GeniusSvg />
  }
];

export const SpielgruppePlus: FunctionComponent<Props> = ({ isAuthenticated }) => {
  const userId = useUserIdParam();
  const subscription = useSubscription(userId);
  useAuthentication(isAuthenticated);

  const isPlusSubscription = subscription?.role === "Spielgruppe Plus";

  return (
    <ContentLayout
      title={"Spielgruppe Plus"}
      siteTitle={"Spielgruppe Online - Spielgruppe Plus"}
      subtitle={isPlusSubscription ? "Aktiv" : "Alle Zusatzfunktionen im Überblick"}
      maxWidth={980}>
      {isPlusSubscription && (
        <div className="alert alert-primary mb-3">
          <b>Sie besitzen eine aktive Spielgruppe Plus Mitgliedschaft.</b>
        </div>
      )}

      <ol className="timeline">
        {FEATURES.map((feature) => (
          <li className="timeline__item" key={feature.title}>
            <div className="timeline__content">
              <div className="panel timeline__card">
                <div className="panel__body">
                  <h3>{feature.title}</h3>
                  <p>{feature.text}</p>
                </div>
              </div>
            </div>
            <div className="timeline__rail" aria-hidden={true}>
              <span className="timeline__dot" />
            </div>
            <div className="timeline__figure" aria-hidden={true}>
              {feature.figure}
            </div>
          </li>
        ))}
      </ol>

      <section className="panel plus-cta">
        <div className="plus-cta__figure" aria-hidden={true}>
          <BoySvg />
        </div>
        <div className="plus-cta__text">
          <h3>{isPlusSubscription ? "Fragen zu Ihrer Mitgliedschaft?" : "Auf Spielgruppe Plus wechseln"}</h3>
          <p>
            Melden Sie sich bei uns unter <strong>info@webtie.ch</strong> — wir schalten Ihnen Spielgruppe Plus frei und
            beantworten alle Fragen.
          </p>
          <a className="btn btn-primary" href="mailto:info@webtie.ch?subject=Spielgruppe%20Plus">
            E-Mail schreiben
          </a>
        </div>
      </section>
    </ContentLayout>
  );
};
